import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { addInteractiveScaleClass } from '../../../../util/addInteractiveScaleClass/addInteractiveScaleClass.js';
import { getDataAttributes } from '../../../../util/getDataAttributes/getDataAttributes.js';
import { extractCommonItemProps } from '../../../../util/layout/layoutPropsExtractor.js';
import { extractPaddings, extractMargins } from '../../../../util/spacing.js';
import '../../../../util/styles/index.js';
import { useButton } from '@react-aria/button';
import { useObjectRef, mergeProps } from '@react-aria/utils';
import { useAdsStyles } from '../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["border", "borderRadius", "borderStyle", "height", "width", "minHeight", "minWidth", "maxHeight", "maxWidth", "backgroundColor", "alignItems", "justifyContent", "gap", "p", "boxShadow", "disableScaleIcon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useButtonBase = function useButtonBase(_ref, ref) {
  var _ref$border = _ref.border,
    border = _ref$border === void 0 ? {
      value: '0'
    } : _ref$border,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? {
      value: '2'
    } : _ref$borderRadius,
    borderStyle = _ref.borderStyle,
    height = _ref.height,
    width = _ref.width,
    _ref$minHeight = _ref.minHeight,
    minHeight = _ref$minHeight === void 0 ? '24px' : _ref$minHeight,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? '24px' : _ref$minWidth,
    maxHeight = _ref.maxHeight,
    maxWidth = _ref.maxWidth,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? 'base.transparent' : _ref$backgroundColor,
    _ref$alignItems = _ref.alignItems,
    alignItems = _ref$alignItems === void 0 ? 'center' : _ref$alignItems,
    _ref$justifyContent = _ref.justifyContent,
    justifyContent = _ref$justifyContent === void 0 ? 'center' : _ref$justifyContent,
    gap = _ref.gap,
    _ref$p = _ref.p,
    p = _ref$p === void 0 ? '0' : _ref$p,
    boxShadow = _ref.boxShadow,
    _ref$disableScaleIcon = _ref.disableScaleIcon,
    disableScaleIcon = _ref$disableScaleIcon === void 0 ? false : _ref$disableScaleIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var objRef = useObjectRef(ref);
  var _getDataAttributes = getDataAttributes(props),
    dataAttributes = _getDataAttributes.dataAttributes,
    restProps = _getDataAttributes.rest;
  var commonItemProps = extractCommonItemProps(restProps);
  var _extractPaddings = extractPaddings(_objectSpread(_objectSpread({}, restProps), {}, {
      p: p
    })),
    paddings = _extractPaddings.paddings,
    restFromPadding = _extractPaddings.rest;
  var _extractMargins = extractMargins(restFromPadding),
    margins = _extractMargins.margins,
    restFromMargin = _extractMargins.rest;
  var _useButton = useButton(restFromMargin, objRef),
    buttonProps = _useButton.buttonProps;
  var isDisabled = buttonProps.disabled;
  var disableProps = isDisabled && {
    backgroundColor: 'state.disabled',
    cursor: 'not-allowed',
    borderColor: 'state.disabled',
    textColor: 'state.disabled'
  };
  var _useAdsStyles = useAdsStyles(),
    getInteractiveState = _useAdsStyles.getInteractiveState,
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var adsStyles = mapAdsStyles(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    backgroundColor: backgroundColor,
    boxShadow: boxShadow,
    display: 'inline-flex',
    alignItems: alignItems,
    justifyContent: justifyContent,
    border: border,
    borderStyle: borderStyle,
    borderRadius: borderRadius,
    cursor: 'pointer',
    minWidth: minWidth,
    minHeight: minHeight,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    width: width,
    height: height,
    gap: gap
  }, commonItemProps), paddings), margins), disableProps));
  var disableContextValues = {
    isDisabled: isDisabled
  };
  if (isDisabled) {
    return {
      buttonProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, adsStyles), buttonProps), dataAttributes), {}, {
        ref: objRef
      }),
      disableContextValues: disableContextValues
    };
  }
  var _getInteractiveState = getInteractiveState({
      type: 'filled'
    }),
    interactiveStateStyles = _getInteractiveState.adsStyles;
  var mergedStyles = mergeProps(interactiveStateStyles, adsStyles);

  // nice scale down effect on click, designer thing :)
  if (!disableScaleIcon) {
    mergedStyles.className = addInteractiveScaleClass(mergedStyles.className, 0.96);
  }
  return {
    buttonProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mergedStyles), buttonProps), dataAttributes), {}, {
      ref: objRef
    }),
    disableContextValues: disableContextValues
  };
};

export { useButtonBase };
//# sourceMappingURL=useButtonBase.js.map
